import { DomainError } from "@econ-v1/domain";
import { DISCOVER_NODE_COMMAND, isDiscoverNodePayload } from "@econ-v1/rpc";
/**
 * The kernel side of the pre-pairing "verify a user-entered address is really a node"
 * command (`client/rpc/src/onboarding/discovery-contract.ts`'s `DISCOVER_NODE_COMMAND`).
 * Delegates entirely to the injected `NodeAddressDiscoverer` (composed in `system/pwa` with
 * `discoverNodeByAddress` from `@econ-v1/adapters-web`, the same way `DiscoveryCommandDispatcher`
 * is composed with a `HomeNodeDialer`) — this class is wiring only: payload validation +
 * command-name routing.
 *
 * The discoverer's result is already the JSON-safe wire shape (`NodeDiscoveryResult`), so no
 * mapping happens here beyond the `JsonValue` cast every other dispatcher in this package
 * performs on its service's plain-object result.
 */
export class NodeDiscoveryCommandDispatcher {
    discoverer;
    next;
    constructor(discoverer, next) {
        this.discoverer = discoverer;
        this.next = next;
    }
    async execute(name, payload) {
        switch (name) {
            case DISCOVER_NODE_COMMAND: {
                if (!isDiscoverNodePayload(payload)) {
                    throw new DomainError({ code: "invalid_request", message: "Invalid discover-node payload" });
                }
                const result = await this.discoverer.discover(payload.address);
                return JSON.parse(JSON.stringify(result));
            }
            default:
                if (this.next !== undefined)
                    return await this.next.execute(name, payload);
                throw new DomainError({ code: "not_found", message: "Host command is not registered" });
        }
    }
}
//# sourceMappingURL=node-discovery-command-dispatcher.js.map